export default 'https://tme.understood.org/assets/Frozen_Bake1_CyclesBake_COMBINED.933f78e5.webp'